/* MARVI OCEAN - Ocean Community: build the mailto link.

   WHY NOT DO THIS IN LIQUID
   Shopify's url_encode is form encoding: it turns a space into '+'. In a
   mailto subject or body a '+' is a literal plus sign, so the email would
   open reading "My+MARVI+photo". encodeURIComponent is the correct function
   and only exists in JS.

   Line breaks are encoded as %0D%0A rather than %0A. Outlook and several
   webmail clients collapse a lone %0A and the message arrives as one
   unbroken paragraph.

   If JS does not run, the link still works: the href falls back to a plain
   mailto with no pre-filled text. */
(function(){
'use strict';
function boot(){
  var btn = document.getElementById('ocoSendBtn');
  if(!btn) return;

  var email   = btn.getAttribute('data-email')   || '';
  var subject = btn.getAttribute('data-subject') || '';
  var body    = btn.getAttribute('data-body')    || '';

  if(!email) return;

  var url = 'mailto:' + email;
  var parts = [];

  if(subject) parts.push('subject=' + encodeURIComponent(subject));
  if(body)    parts.push('body='    + encodeURIComponent(body.replace(/\r?\n/g, '\r\n')));

  if(parts.length) url += '?' + parts.join('&');

  /* A handful of very old clients cap the URL near 2000 characters.
     If someone writes an essay in the theme editor, drop the body rather
     than hand the browser a truncated link. */
  if(url.length > 1900 && parts.length > 1){
    url = 'mailto:' + email + '?subject=' + encodeURIComponent(subject);
  }

  btn.setAttribute('href', url);
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
})();
